import React, {Component} from "react"
import PropTypes from "prop-types"
import {withApollo} from "react-apollo"

import getId from "@irati/utils/id"
import {insGlobalMutation} from "@irati/insights/apollo/client/mutation/insGlobal"
import {insWizardMutation} from "@irati/insights/apollo/client/mutation/InsWizard"

import EditController from "../../components/Wizard/Edit/EditController"
import sitemap from "../sitemap"


class ScheduleEdit extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired
  }

  componentDidMount() {
    this.saveRequiredParamsToState()
  }

  componentWillUnmount() {
    const {client} = this.props
    const variables = {params: {cycleId: null}}
    client.mutate({mutation: insGlobalMutation, variables})
  }

  saveRequiredParamsToState = () => {
    const {client, match: {params: {scheduleId}}} = this.props
    const cycleId = scheduleId || null
    const variables = {params: {cycleId}}
    client.mutate({mutation: insGlobalMutation, variables})
    const wizardVariables = {
      isEditMode: true,
      prevURL: sitemap.homepage.url,
      nextURL: sitemap.scheduleEditSummary.url
    }
    client.mutate({mutation: insWizardMutation, variables: {params: wizardVariables}})
  }


  render() {
    const idNamespace = getId("ScheduleEdit", this.props, {force: true})

    return (
      <EditController id={idNamespace} />
    )
  }
}

export default withApollo(ScheduleEdit)
